var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReferralIconGradient = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#referral-icon-gradient_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#referral-icon-gradient_svg__b)",
  d: "M30.75 7.501h-2.902a5.003 5.003 0 0 0-.354-5.485A5 5 0 0 0 24.177.05a5.02 5.02 0 0 0-3.732.955C19.401 1.789 18.606 2.8 18 3.829c-.606-1.027-1.401-2.04-2.445-2.821a5 5 0 0 0-3.732-.956 5 5 0 0 0-3.315 1.964 5 5 0 0 0-.957 3.732c.09.628.3 1.22.598 1.753H5.25A5.256 5.256 0 0 0 0 12.751v.75c0 1.655 1.346 3 3 3h30c1.654 0 3-1.345 3-3v-.75a5.256 5.256 0 0 0-5.25-5.25m-8.506-4.093a2.01 2.01 0 0 1 1.509-.386 2.03 2.03 0 0 1 1.34.794c.328.435.464.97.387 1.507-.076.539-.358 1.014-.841 1.377-.055.044-.555.417-1.527.8H19.65c.333-1.136 1.125-2.991 2.595-4.094zM11.313 6.664a2.02 2.02 0 0 1-.792-1.34 2.02 2.02 0 0 1 .388-1.51 2.02 2.02 0 0 1 1.34-.793 2.02 2.02 0 0 1 1.509.387c1.47 1.102 2.26 2.956 2.595 4.093h-3.462c-.972-.382-1.476-.759-1.575-.837zm8.673 19.805a1.374 1.374 0 0 1 .89-2.424h4.126l1.461-4.098a1.374 1.374 0 0 1 2.577 0l1.461 4.098h4.126a1.376 1.376 0 0 1 .886 2.427l-3.254 2.65 1.346 4.098a1.37 1.37 0 0 1-.467 1.521 1.38 1.38 0 0 1-1.59.063l-3.786-2.466-3.723 2.492a1.376 1.376 0 0 1-2.078-1.556l1.294-4.147-3.269-2.66zM19.573 36H10.5a7.5 7.5 0 0 1-7.5-7.5v-9h20.436l-.55 1.544h-2.01a4.39 4.39 0 0 0-4.106 2.865c-.631 1.714-.12 3.661 1.323 4.887l1.694 1.377-.687 2.205A4.38 4.38 0 0 0 19.572 36"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "referral-icon-gradient_svg__b",
  x1: 18.001,
  x2: 18.001,
  y1: 0,
  y2: 36.001,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#857BE3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3664C4"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "referral-icon-gradient_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
})))));
export { SvgReferralIconGradient as ReactComponent };
export default __webpack_public_path__ + "8fffd843dced94ce311f9ba0ae021c42.svg";